import React, { useEffect, useContext } from 'react';
import PropTypes from 'prop-types';

import { getLeadStatus, fsPageOnLoad } from 'home/view/upgrade-order/utils';
import { LEAD_STATUS } from 'home/view/upgrade-order/constants';
import { CONTEXT } from 'home/view/upgrade-order/context';

import ExistingDetailsAccordion from 'home/view/upgrade-order/components/accordions/ExistingDetailsAccordion';
import UpgradeOrderDetailsAccordion from 'home/view/upgrade-order/components/accordions/UpgradeOrderDetailsAccordion';
import KamPricingComponent from 'home/view/upgrade-order/components/accordions/KamPricingComponent';
import ThankYouPage from 'home/view/upgrade-order/components/common/ThankYouPage';

function KamJourney(props) {
  const { leadData, pnqFormOpen, setIsPnqFormOpen, showCancelPage = false } = props;

  const { userType } = useContext(CONTEXT);

  useEffect(() => {
    fsPageOnLoad(leadData, userType);
  }, [leadData, userType]);

  useEffect(() => {
    if (leadData) {
      const leadStatus = getLeadStatus(leadData);
      const pnqFormShow = !(leadStatus === LEAD_STATUS.LEAD_IN_PROGRESS || leadStatus === LEAD_STATUS.FEASIBILITY_PENDING || leadStatus === LEAD_STATUS.LOCATION_NOT_FEASIBLE);

      setIsPnqFormOpen(pnqFormShow);
    }
  }, [leadData]);

  const isLeadCancelled = (leadData) => {
    let isCancelled = false;
    const { leadStatus = '' } = leadData;

    if (leadStatus === LEAD_STATUS.LEAD_CANCELLED || leadStatus === LEAD_STATUS.ORDER_CANCELLED) {
      isCancelled = true;
    }

    return isCancelled;
  };

  return (
    <React.Fragment>
      {Object.keys(leadData).length > 0 ? (
        <div className="kam-journey">
          {showCancelPage || isLeadCancelled(leadData) ? (
            <ThankYouPage {...props} showCancelPage={showCancelPage} />
          ) : (
            <React.Fragment>
              <ExistingDetailsAccordion {...props} />
              <UpgradeOrderDetailsAccordion {...props} />
              {pnqFormOpen && <KamPricingComponent {...props} />}
            </React.Fragment>
          )}
        </div>
      ) : null}
    </React.Fragment>
  );
}

KamJourney.propTypes = {
  leadData: PropTypes.object.isRequired,
  setLeadData: PropTypes.func.isRequired
};

export default KamJourney;
